import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './contexts/AuthContext';
import HomePage from './pages/HomePage';
import TextTranslationPage from './pages/TextTranslationPage';
import AudioResultPage from './pages/AudioResultPage';
import AudioPlayingPage from './pages/AudioPlayingPage';
import LoginPage from './pages/LoginPage';
import Header from './components/Header';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: #f8f9fa;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
    sans-serif;
`;

const MainContent = styled.main`
  padding: 0;
`;

function App() {
  return (
    <AuthProvider>
      <AppContainer>
        <Router>
          <Header />
          <MainContent>
            <Routes>
              <Route path='/login' element={<LoginPage />} />
              <Route
                path='/'
                element={
                  <ProtectedRoute>
                    <HomePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/text'
                element={
                  <ProtectedRoute>
                    <TextTranslationPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/audio-result'
                element={
                  <ProtectedRoute>
                    <AudioResultPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/audio-playing'
                element={
                  <ProtectedRoute>
                    <AudioPlayingPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </MainContent>
          <ToastContainer
            position='top-center'
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme='light'
          />
        </Router>
      </AppContainer>
    </AuthProvider>
  );
}

export default App;
